import { render, staticRenderFns } from "./ShopHistoryView.vue?vue&type=template&id=1f6072a0&"
import script from "./ShopHistoryView.vue?vue&type=script&lang=js&"
export * from "./ShopHistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports